import React from 'react';
import { Icon, IconProps } from '~web/view/components/ui/icon.component';

export const CloseIcon: React.FunctionComponent<IconProps> = ({
  width = 18,
  height = 18,
  ...rest
}) => (
  <Icon width={width} height={height} viewBoxHeight={18} viewBoxWidth={18} {...rest}>
    <path d="M17.7072 2.6115L11.3186 9.00008L17.7072 15.3886L15.3886 17.7072L9.00008 11.3186L2.6115 17.7072L0.292969 15.3886L6.68154 9.00008L0.292969 2.6115L2.6115 0.292969L9.00008 6.68154L15.3886 0.292969L17.7072 2.6115Z" />
  </Icon>
);



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/web/src/js/view/components/ui/icon/close-icon.component.tsx